export default "__VITE_ASSET__Ijn_3ASS__"